import { SessionVisibility } from "@swiggy-private/checkout-core";
import { LOCAL_STORAGE_KEYS } from "@swiggy-private/core-ui";

export const ICON_CLASS = "footer-comms-savings-strip-wrapper-class";

export const FOOTER_COMMS_CLICK_FREQUENCY_CAP_PAYLOAD = {
    id: "FOOTER_COMMS_CLICK_FREQUENCY_CAP_ID",
    key: LOCAL_STORAGE_KEYS.FOOTER_COMMS_CLICK_FREQUENCY_CAPPING_KEY,
    sessionVisibility: SessionVisibility.EVERYTIME_PER_SESSION,
    maxFrequency: 0,
};

export const FOOTER_COMMS_VIEW_FREQUENCY_CAP_PAYLOAD = {
    id: "FOOTER_COMMS_VIEW_FREQUENCY_CAP_ID",
    key: LOCAL_STORAGE_KEYS.FOOTER_COMMS_VIEW_FREQUENCY_CAPPING_KEY,
    sessionVisibility: SessionVisibility.ONCE_PER_SESSION,
    maxFrequency: 3,
};
